import Box from '@/components/UI/box/Box';
import styles from './MidTermFeature.module.scss';
import FilterChips from '../reusabe/filterChips/FilterChips';
import { useRef } from 'react';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import useDrawer from '@/hooks/useDrawer';
import useDevice from '@/hooks/useDevice';
import Menu from '@/components/UI/menu/Menu';
import Drawer from '@/components/UI/drawer/Drawer';
import FeaturesList from './featuresList/FeaturesList';
import { useForm } from 'react-hook-form';
import useMidTermFilters from '@/components/search/hooks/useMidTermFilters';
import { midTermFeatures } from '../constants/midTermFeatures';
export type FeatureKeys = (typeof midTermFeatures)[number]['list'][number]['query'];
export type MidTermFeatureData = { [K in FeatureKeys]?: boolean };
const MidTermFeature = () => {
  const {
    setQuery,
    queries
  } = useSearchParams();
  const {
    midTermFeatures,
    updateQueryParams,
    clearFilters,
    extractActiveFilters,
    useSyncFormWithQuery
  } = useMidTermFilters();
  const {
    handleSubmit,
    control,
    reset
  } = useForm<MidTermFeatureData>();
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const closeRef = useRef<any>(null);
  const {
    isMobile
  } = useDevice();
  const featureQueryKeys = midTermFeatures.flatMap(section => section.list.map(item => item.query));
  const featureQueryKeySet = new Set(featureQueryKeys);
  const selectedNumber = Object.entries(extractActiveFilters(queries)).filter(([key, value]) => featureQueryKeySet.has(key) && value !== undefined && value !== null && value !== '').length;
  const open = isDrawerOpen('FEATURES');
  useSyncFormWithQuery(queries, reset);
  const onSubmit = form => {
    updateQueryParams(form, setQuery);
  };
  const handleResetFilter = e => {
    e.stopPropagation();
    const clearedFilter = clearFilters(queries, featureQueryKeys);
    reset(clearedFilter);
    setQuery(clearedFilter);
  };
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('FEATURES');
    }
  };
  const handleClose = () => {
    drawerClose();
  };
  return <Box className={styles['mid-term-feature-container']} data-sentry-element="Box" data-sentry-component="MidTermFeature" data-sentry-source-file="MidTermFeature.tsx">
      <FilterChips type="secondary" checked={!!selectedNumber} handleClick={handleClick} handleClean={handleResetFilter} label={selectedNumber ? `امکانات (${selectedNumber})` : 'امکانات'} endIcon name="midterm_feature_filter" id="mid-term-feature-chips" data-sentry-element="FilterChips" data-sentry-source-file="MidTermFeature.tsx" />
      {!isMobile ? <Menu ref={closeRef} id="features" open={open} handleClose={drawerClose} className={styles['filter-item-container']} menuButtonId="mid-term-feature-chips">
          <FeaturesList handleClose={drawerClose} control={control} handleSubmit={handleSubmit} onSubmit={onSubmit} handleResetFilter={handleResetFilter} midTermFeatures={midTermFeatures} />
        </Menu> : <Drawer open={isDrawerOpen('FEATURES')} onClose={handleClose} fullHeight>
          <FeaturesList handleClose={drawerClose} control={control} handleSubmit={handleSubmit} onSubmit={onSubmit} handleResetFilter={handleResetFilter} midTermFeatures={midTermFeatures} />
        </Drawer>}
    </Box>;
};
export default MidTermFeature;